<!-- Calendar controller -->
@if (view) {
  <div class="calendar-controller mt-1">
    <app-user-group-list (onSelectionChange)="selectedGroup = $event; groupSelected()"></app-user-group-list>
    <div [ngStyle]="{ overflow: 'hidden' }" class="card-title-text calendar-title">
      <!-- Arrow navigations -->
      <div class="cal-top-col text-center">
        <button mat-icon-button (click)="navButtonsClick('previous')">
          <mat-icon>chevron_left</mat-icon>
        </button>
        <button mat-icon-button (click)="navButtonsClick('today')">
          <mat-icon>today</mat-icon>
        </button>
        <button mat-icon-button (click)="navButtonsClick('next')">
          <mat-icon>chevron_right</mat-icon>
        </button>
      </div>
      <!-- Date title -->
      <div class="cal-top-col text-center">
        <h5 class="m-0" [style.lineHeight]="'40px'">
          {{ viewDate | calendarDate: view + 'ViewTitle' : locale }}
        </h5>
      </div>
      <!-- Month, day, week view toggle buttons -->
      <div class="cal-top-col text-center">
        <button mat-icon-button [matTooltip]="'Calendar.MonthView' | translate" (click)="setView('month')" [class.active]="view === 'month'">
          <mat-icon>view_comfy</mat-icon>
        </button>
        <button mat-icon-button [matTooltip]="'Calendar.WeekView' | translate" (click)="setView('week')" [class.active]="view === 'week'">
          <mat-icon>view_week</mat-icon>
        </button>
        <button mat-icon-button [matTooltip]="'Calendar.DayView' | translate" (click)="setView('day')" [class.active]="view === 'day'">
          <mat-icon>view_day</mat-icon>
        </button>
      </div>
      <div class="mt-1">
        <div>
          <button mat-flat-button class="mb-05" color="primary" (click)="addEvent()">
            {{ 'Global.CreateEvent' | translate }}
          </button>
        </div>
        <div class="mt-1">
          <button mat-flat-button color="primary" class="mb-05" (click)="refresh()">
            <mat-icon>refresh</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
}
